const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const isProduction = window.location.hostname === 'spono.ai' || 
                     window.location.hostname === 'www.spono.ai';

// Define base URLs
const DEV_API_URL = 'http://localhost:5001';
const PROD_API_URL = 'https://spono.ai';

// Export configuration variables
const config = {
  // Fix BASE_URL to properly use production URL
  BASE_URL: isDevelopment ? DEV_API_URL : PROD_API_URL,
  UPLOADS: isDevelopment ? `${DEV_API_URL}/uploads` : `${PROD_API_URL}/uploads`,
  IMAGE_URL: isDevelopment ? `${DEV_API_URL}/uploads` : `${PROD_API_URL}/uploads`,
  
  // Environment flags
  isDevelopment,
  isProduction,
  
  // Timeout and retry configuration
  TIMEOUT: 15000,
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 2000,
  
  // Flag to enable more debugging in production
  DEBUG: isDevelopment, // Changed to enable debug in development, not production
  
  // API Version (useful for future versioning)
  API_VERSION: 'v1',

  // Helper function to get full URL
  getFullUrl: function(path) {
    if (!path) return null;
    if (path.startsWith('http')) return path;
    // Ensure no duplicate slashes
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${this.BASE_URL}${normalizedPath}`;
  },

  // Add cache busting for images  
  getImageUrl: function(imagePath) {
    if (!imagePath) return null;
    const baseUrl = this.getFullUrl(imagePath);
    return `${baseUrl}?t=${Date.now()}`;
  }
};

// Debug logging to help troubleshoot
if (config.DEBUG) {
  console.log('Environment Detection:', {
    hostname: window.location.hostname,
    isDevelopment,
    isProduction,
    BASE_URL: config.BASE_URL
  });
}

export default config;
